// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P3Hb","label":"styles_label__2nu4V"};